module.exports = __webpack_public_path__ + "img/cert_3.a7fc2961.jpg";